import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
// components
import InfoDistribution from '../../../../components/modules/master/info-distribution';
import InfoDistributionMiddleware from '../../../../middleware/modules/master/info-distribution';
import { Helmet } from 'react-helmet';
import i18n from '../../../../i18n';
// middlewares
 

const mapStateToProps = ({ auth,infoDistribution}) => ({
  authUser:auth.authUser,
  isProcessing: infoDistribution.isProcessing,
  isError: infoDistribution.isError,
  errorMessage: infoDistribution.errorMessage,
  datalist:infoDistribution.data,
  showModal:infoDistribution.showModal,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    create: () =>InfoDistributionMiddleware.create(),
    reset: () =>InfoDistributionMiddleware.resetList(),
    search: data =>InfoDistributionMiddleware.list(data),
    update: data =>InfoDistributionMiddleware.update(data),
    delete: (id,search) =>InfoDistributionMiddleware.beforeDelete(id,search),
    getHelper: (id, search) =>InfoDistributionMiddleware.getHelper(id, search),
  }, dispatch);
};
class InfoDistributionContainer extends Component {
  
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
    search: PropTypes.func.isRequired
  }

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  }

  constructor(props){
    super(props)
    this.deleteItem=this.deleteItem.bind(this);
    this.createItem=this.createItem.bind(this);
    this.updateItem=this.updateItem.bind(this);
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
   this.props.search(search);
  
  }

  deleteItem(id,search){
    this.props.delete(id,search)
  }
  updateItem(id){
    
    this.props.update(id)
    this.props.getHelper()
  }

  createItem(){
    this.props.create()
   
  }
  render() {
    const {isProcessing, search , datalist,showModal,authUser,showModalConfig} = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("InfoDistribution List")}
          </title>
        </Helmet>
      <InfoDistribution
        authUser={authUser}
        search={search}
        data={datalist}
        isProcessing={isProcessing}
        showModal={showModal}
        showModalConfig={showModalConfig}
        deleteItem={this.deleteItem}
        updateItem={this.updateItem}
        createData={this.createItem}
       
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InfoDistributionContainer);
